import React from "react";

import css from "./FloatingSignup.module.scss";

type Props = {
  buttonLink: string;
};

export default function FloatingSignup({ buttonLink }: Props) {
  return (
    <div className={css.floatingSignupContainer}>
      <div className={css.floatingSignupContent}>
        <h3>Create a Free Account on Stotles</h3>
        <p className={css.floatingSignupDescription}>
          Stotles is your single source for government tenders, contracts, frameworks and much more.
          Sign up for free.
        </p>
      </div>
      <div className={css.floatingSignupButtons}>
        <button
          className={css.floatingSignupButtonTender}
          onClick={() => window.open(buttonLink, "_blank")}
        >
          Start for Free
        </button>
        <button
          className={css.floatingSignupButtonAlert}
          onClick={() => window.open(buttonLink, "_blank")}
        >
          Set an Alert
        </button>
      </div>
    </div>
  );
}
